import { useSyncStore } from "../state/syncStore";

export function OfflineBanner() {
  const isOnline = useSyncStore((s) => s.isOnline);
  const outboxSize = useSyncStore((s) => s.outboxSize);
  const syncState = useSyncStore((s) => s.syncState);

  if (isOnline && outboxSize === 0 && syncState !== "error") return null;

  if (!isOnline) {
    return (
      <div
        role="status"
        data-testid="offline-banner"
        className="bg-warning-soft border border-warning text-warning rounded-xl px-4 py-3 flex items-center gap-3 text-sm"
      >
        <span aria-hidden className="text-lg leading-none">⚠</span>
        <span className="flex-1">
          Offline — Antworten werden lokal gespeichert und später synchronisiert.
          {outboxSize > 0 && ` ${outboxSize} ausstehend.`}
        </span>
      </div>
    );
  }

  if (syncState === "syncing") {
    return (
      <div
        role="status"
        data-testid="syncing-banner"
        className="bg-success-soft border border-success text-success rounded-xl px-4 py-3 flex items-center gap-3 text-sm"
      >
        <span aria-hidden className="text-lg leading-none animate-pulse">↻</span>
        <span className="flex-1">Synchronisiere {outboxSize || 1} {outboxSize === 1 ? "Antwort" : "Antworten"} …</span>
      </div>
    );
  }

  if (syncState === "error") {
    return (
      <div
        role="alert"
        data-testid="sync-error-banner"
        className="bg-danger-soft border border-danger/40 text-danger rounded-xl px-4 py-3 flex items-center gap-3 text-sm"
      >
        <span aria-hidden className="text-lg leading-none">!</span>
        <span className="flex-1">Sync fehlgeschlagen — Versuch wird wiederholt.</span>
      </div>
    );
  }

  return null;
}
